export enum BuilderEstimatorSteps {
  LAND_DETAILS = "Land Details",
  VIEW_DESIGN = "View Designs",
  SELECT_DESIGN = "Select Design",
  SELECT_FACADE = "Select Facade",
  SELECT_EXTERNAL_COLOURS = "Select External Colours",
  SELECT_INTERNAL_COLOURS = "Select Internal Colours",
  SELECT_INCLUSIONS = "Select Inclusions",
  OPTIONAL_UPGRADES = "Optional Upgrades",
  SUMMARY = "Summary",
}
